module.exports = __webpack_public_path__ + "img/starr_logo_menu_2.0d1419f2.png";